import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { fetchFoundations, selectFoundationsFirstLoad } from "../model"
import { useEffect } from "react"
import { FoundationList } from "./foundation-list"

export const FoundationsPage = () => {
    const dispatch = useAppDispatch()
    const foundationsFirstLoad = useAppSelector(selectFoundationsFirstLoad)

    useEffect(() => {
        if (foundationsFirstLoad) {
            dispatch(fetchFoundations())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Благотворительные фонды" />
            <FoundationList />
        </div>
    )
}